          <template>
    <v-card class="transparent stickytopconscious" width="100%" height="100%">
    <!-- <v-card class="transparent"> -->
      <!-- <div  class="my-10"> -->
        <v-card class="transparent" width="100%" flat>
            <v-parallax
            height="150"
            src="@/assets/Parallax_Logo.jpeg"
            >
              
              <v-row
              align="center"
              justify="center"
            >
              <v-col class="parallaxbgcontentgrad text-center" cols="12">
                <h1 class="display-2 font-weight-thin mb-4">Financial</h1>
                <h4 class="headline">FREEDOM</h4>
              </v-col>
            </v-row>
            </v-parallax>            
            </v-card>
            <!-- </div>-->
      <!-- <div  class="my-10"> -->
        <v-card color="#FFFFFF" width="100%" flat>
            <v-layout row wrap class="justify-center mx-3">
                <v-flex lg8 md9 sm8 xs12 class="mx-2">
                    <h2 class="primary--text mx-1 my-3" align="center">Liquidation</h2>          
                <div>This process is applicable on companies and not on your personal capacity. This process is intended for those companies that have virtually no chance of surviving, and as a result, the shareholders wish to&nbsp; end the existence of the company as quickly, safely and efficiently as possible. By bringing this application in time you will prevent other creditors from also bringing the application, thus also preventing unnecessary audits and claims against your company, that might take years to resolve!&nbsp;</div><div><br></div><div>With this process a company will be unregistered and all assets (if applicable) within the company will be sold and paid out to the involved creditors, as contribution to their outstanding claims. Should there be a shortfall it will be written off.&nbsp;</div><div><br></div><div>In many instances personal surety is signed by the owner or shareholders in which case this process will not be sufficient enough by itself, as the creditors will have a personal claim against the owners or shareholders. And in such case, when the claim is too immense to undertake an agreement with the particular creditor, it would be advisable to apply for a Voluntary Sequestration of estate alongside with this process.&nbsp;</div><div><br></div><div>For more information, contact us, or submit an application</div><br><br>
                </v-flex>
                </v-layout>            
            </v-card>
            <!-- </div>-->
      <!-- <div  class="my-10"> -->
        <v-card class="transparent" width="100%" flat>
        <v-img src="@/assets/Helping_Hand.jpeg"  width="100%" height="300">
            <v-layout row wrap class="justify-center mx-3">
                <v-flex lg8 md9 sm8 xs12 class="mx-2">
                </v-flex>
                </v-layout>
        </v-img>            
            </v-card>
            <!-- </div>-->
            
        </v-card> 
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'


export default {
name: 'Liquidation',
metaInfo: {
    title: 'Liquidation Service - Tribunes SA',
    meta: [
      {
        name: 'description',
        content: `Efficiently dissolve your company with this process designed for insolvent companies. Prevent creditor claims and audits by taking timely action. Contact us for details.`
      },
      {
        name: 'keywords',
        content: 'Liquidation, Insolvency, Tribunes SA'
      }
    ]
  },
    components: {
        },
    data() {
    return {      
      UserRecord: {},
      rules: {
        youtubeurl: value => {
            const pattern = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
            return pattern.test(value) || "Not a Youtube Video Link.";
          },
          min8Chars: value => value.length >= 8 || "Min. 8 characters",
          required: value => !!value || "Required.",
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          },
          url: value => {
            const urlpattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); 
            return urlpattern.test(value) || "Invalid Link.";
          }
        },
    }
    },
    computed:{
      userLoggedIn () {
      return this.$store.getters.user
    },
      
      

    },
    mounted () {
  window.scrollTo(0, 0)
},
    created(){
      this.FocusedViewToggle()
      this.IntranetViewToggle()
      this.CheckUser()

    },
    
    methods: {
      IntranetViewToggle(){
        this.$emit('IntranetViewToggle',false)
      },
      FocusedViewToggle(){
        this.$emit('FocusedViewToggle',false)
      },
      async CheckUser(){
            let vm = this
            await firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                  db.collection('users').doc(user.uid).onSnapshot(snapshot => {
              var userdetails = snapshot.data()

              vm.UserRecord = userdetails
              vm.UserRecord.id = user.uid
              console.log(vm.UserRecord)
                  })
                }
                else{
                }
            })
        },
          DateFormatter(date){
            if(date){
            let yearstring = date.split('-')[0]
              let monthstring = date.split('-')[1]
              let daystring = date.split('-')[2]
              let yearnumber = Number(yearstring)
              let monthnumber = Number(monthstring)
              let daynumber = Number(daystring)
              return new Date(yearnumber, monthnumber-1, daynumber)
              }
            else{
              return null
            }
          },

    }    
}
</script>

<style>
.parallaxbgcontentgrad {
  background-image: linear-gradient(to right, rgba(20,26,31,0.5), rgb(189,199,209, 1));
}
.transoutline{
    border: 1px solid black;
    background-color:pink
    /* color: rgba(255,255,255,0.05) */
}
.v-card--reveal {
    /* background-color: rgba(176, 7, 255, 0.5); */
  background-color: rgba(255, 193, 7, 0.75);
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
  z-index:10
}

.iconoutline{
  text-shadow: 0 0 3px #FF0000;
}
</style>

        
            
        